import styled from "styled-components";
import { IdxListingContainer } from "../../utilComponent/idxListing/idxListing.style";



export const SoldListingContainer = styled(IdxListingContainer)`
    
`
